var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaptopEhr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.19388 25.7195c.14431.1862.36322.2805.65059.2805h24.31093c.2879 0 .507-.0946.6513-.2813.1671-.2162.1911-.5007.1933-.6215h-26c.00241.1213.02694.4072.19388.6223z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.47122 22.6884-.32864 1.0066h14.91512l-.4146-1.0066z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.7275 21.5695.0818-.601-2.77994.0105-.1928.5905z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.4347 20.9436-2.9671.0112v.6147h3.0659z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.5535 21.6965h-3.0859v.8649h3.2225z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.91513 20.9794-2.24547.0084-.35319.5817h2.406z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.51272 22.5614h3.07968l.1178-.8649h-2.91509z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.6617 21.6965.1366.8649h3.7925l-.3562-.8649z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.7093 22.5614h3.6508l-.4926-.893v.0281h-3.5145z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.1823 21.5695-.2633-.639-3.3762.0127.0989.6263z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.68102 21.6965h-2.44164l-.52517.8649h2.68442z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.813 21.5695-.3598-.6522-3.4159.0128.2634.6394z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4301 22.6884h-3.6685l.4146 1.0066h3.8091z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.63712 22.6884-.61124 1.0066h3.00265l.32864-1.0066z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.8352 21.5695h3.5261v-.6143l-3.4442.0129z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.7001 22.5614h3.6612v-.8649h-3.5434z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m26.0666 20.086h-20.13332l-2.88323 4.8843h25.89975zm-20.49227 2.4894v-.014h.00848l1.03236-1.7002.02705-.0002 18.86818-.0709 1.6721 3.0318h-22.36507z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.0789 7.16394c0-.64181-.4373-1.16394-.9748-1.16394h-18.1703c-.53753 0-.97482.52213-.97482 1.16394v12.79516h20.11992zm-.8667 11.15436c0 .2967-.2021.5382-.4506.5382h-17.52307c-.2485 0-.45063-.2415-.45063-.5382v-10.72247c0-.2967.20213-.53806.45063-.53806h17.52307c.2485 0 .4506.24136.4506.53806z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.5 16c.2761 0 .5.2239.5.5v1c0 .2761-.2239.5-.5.5h-1c-.2761 0-.5-.2239-.5-.5v-1c0-.2761.2239-.5.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.5 16c.2761 0 .5.2239.5.5v1c0 .2761-.2239.5-.5.5h-1c-.2761 0-.5-.2239-.5-.5v-1c0-.2761.2239-.5.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.5 16c.2761 0 .5.2239.5.5v1c0 .2761-.2239.5-.5.5h-1c-.2761 0-.5-.2239-.5-.5v-1c0-.2761.2239-.5.5-.5z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.5 13c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-7c-.2761 0-.5-.2239-.5-.5s.2239-.5.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.5 11c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-7c-.2761 0-.5-.2239-.5-.5s.2239-.5.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.5 9c.2761 0 .5.22386.5.5s-.2239.5-.5.5h-7c-.2761 0-.5-.22386-.5-.5s.2239-.5.5-.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m8.75865 14h4.47105c.5627 0 .762-.1503.762-.4441 0-.8616-1.1505-2.0504-2.997-2.0504-1.8442 0-2.9947 1.1888-2.9947 2.0504 0 .2938.19935.4441.75865.4441z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 11c.8016 0 1.5-.6606 1.5-1.52063 0-.84978-.6984-1.47937-1.5-1.47937-.8028 0-1.5.64335-1.5 1.48624 0 .85316.6936 1.51376 1.5 1.51376z",
    opacity: 0.4,
    id: "OriginallyDesignedByAshAlom(C)2019"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopEhr);
export default __webpack_public_path__ + "static/media/Laptop_EHR.f651edb7414f97ac618fa5bbfa9e805d.svg";
export { ForwardRef as ReactComponent };